import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env/environment'
import { IChatSnapshot } from '@app/support-module/core/types'

/**
 * Ответ от `GET /help_desk/client/organizations/:organization_id/chat`.
 * Форма бэка — подмножество снапшота (без `working_hours`), см. swagger.
 */
export type IClientChatResponse = Omit<IChatSnapshot, 'working_hours'>

@Injectable({ providedIn: 'root' })
export class GetClientChatQuery {
  constructor(private httpClient: HttpClient) {}

  call(organizationId: number): Observable<IClientChatResponse> {
    const url = `${environment.api.app}/help_desk/client/organizations/${organizationId}/chat`
    return this.httpClient.get<IClientChatResponse>(url)
  }
}
